export const PEDESTAL_PATH = 'tumby';
export const MIRRORS_PATH = 'zerkala';
export const CLOSET_PATH = 'shkafy';

export const PEDESTAL_VALUE = 'Тумбы';
export const CLOSET_VALUE = 'Шкафы';
export const MIRRORS_VALUE = 'Зеркала';

export const HANDING_VALUE = 'подвесные';
export const FLOOR_VALUE = 'напольные';
export const WITH_SINK_VALUE = 'с раковиной';
export const UNDER_WASHING_MACHINE_VALUE = 'под стиральную машину';
export const LED_MIRRORS_VALUE = 'зеркала с подсветкой';
export const MIRROR_CABINETS_VALUE = 'зеркальные шкафы';

export const HANDING_PATH = 'podvesnye';
export const FLOOR_PATH = 'napolnye';
export const UNDER_WASHING_MACHINE_PATH = 'pod_stiralnuyu_mashinu';
export const WITH_SINK = 's_rakovinoi';
export const LED_MIRRORS_PATH = 's_podsvetkoi';
export const MIRROR_CABINETS_PATH = 'zerkalnye_shkafy';
